import React, { Component } from 'react';
import { createRef } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { useLanguage, LanguageContext } from './../../context/LanguageContext';

import * as bidSessionActions from './../../data/bidSession/actions';
import * as linearCalendarActions from '../../data/linearCalendar/actions';
import { copyCombinedPreference } from '../../data/bidClasses/productionActions';
import { fetchPreviousBidSession } from '../../data/bidSession/productionActions';
import MainCardContainer from './../../components/MainCardContainer/';
import LinearCalendar from '../../components/LinearCalendar';
import LegalityCheck from '../../components/LinearCalendar/LegalityCheck';
import CardRow from '../../components/CardRow';
import EmployeeStatistics from './components/EmployeeStatistics';
import EmployeeStatistic from './components/EmployeeStatistics/EmployeeStatistic';
import CardHead from '../../components/CardHead';
import BidTable from './components/BidTable/';
import { openBidsBuffer, openTimeSearchConfig } from '../../settings/settings';
import { httpStatus } from './../../data/constants/';
import * as utils from './../../utilities/calendarUtilities';
import Loader from './../../components/Loader';
import LinearCalendarTable from '../../components/LinearCalendar/LinearCalendarTable';
import OtherOptions from './components/OtherOptions';
import { DefaultButton } from '../../components/Buttons';
import {
  getBidMode,
  BidMode,
  getTotalCredits,
  movePreference,
  orderPreferences,
  bidSessionUpdateWeight,
  requestWeightSorting,
  sortPreferences,
  moveItem,
  processPreferences,
  getLastBidScopeUsed,
  getLastBidScopeUsedString,
  getStaffId,
  isOptionLevelIsSmallerEqualThanReserve,
  isOptionLevelIsBiggerEqualThanReserve,
  groupByGroupSequence
} from './helpers';
import Notification from './../../components/Notification';
import { getDateStr } from './../../utilities/helpers';
import {
  buildAddRequestData,
  isActivityStartsInBidSessionPeriod
} from '../../components/OpenTimeSearch/components/AddRequest/helpers';
import AlertDialog from '../../components/AlertDialog';
import ReportDialog from '../../components/ReportDialog';
import BidSessionsList from '../../components/BidSessionsList';
import {
  updateBidSessionSuccess,
  importPreviousBidPreferences
} from '../../data/bidSession/productionActions';
import { RESERVE_DOWN_TO, RESERVE_BID_SCOPE, BID_TYPES, LOADSTANDING_KEY, KINDOFBID } from "../../data/constants";

import './styles.scss';

const Button = withStyles({
  root: {
    marginRight: '10px',
    color: 'white',
    backgroundColor: '#009688',
    borderColor: '#009688',
    '&:hover': {
      backgroundColor: '#009688'
    }
  }
})(DefaultButton);


class BidSession extends Component {
  static contextType = LanguageContext;

  constructor(props) {
    super(props);
    const { match } = this.props;
    this.state = {
      bidPreferences: { entries: [] },
      open: false,
      preferenceAdded: false,
      statusDisplay: false,
      statusDisplayText: '',
      alertDialogDisplay: false,
      alertDialogDisplayText: '',
      isReserveLineAlert: false,
      applyStandingBidsSelected: false,
      // Separate reserve line alert state
      reserveLineAlertDisplay: false,
      reserveLineAlertText: '',
      isTransitioningDialogs: false,
      requestAll: false,
      activity: [],
      bidSessionId: match.params.bidId,
      bidMode: '',
      updatedReserveLineType: [],
      isReserveLineTypeSaveFail: false,
      standingBidAppliedReserveLinetype: false,
      bidSessionData: {},
      isDisplayedErrorMessage: false,
      configureReserveLineType: [],
      openReportDialog: false,
      loadingBidTable: false,
      loadingImportPreviousBids: false,
      openImportDialog: false,
      currentBidScope: getLastBidScopeUsedString(),
      // BidSessionsList state for AlertDialog
      alertDialogSelectedBidSessionId: null,
      alertDialogBidPreferences: [],
      alertDialogCombinedGroups: [],
      alertDialogSelectedCombinedPreferencesId: '',
      alertDialogSelectedGroupId: null,
      alertDialogGroupPreferences: [],
      alertDialogReserveLineNames: '',
      previousBidSessions: [],
      loadingPreviousBidSessions: false,
    };

    this.preferenceHasChange = false;
    this.firstLoad = true;
    this.reserveLineMessageShown = false;

    // Ref for BidTable
    this.bidTableRef = createRef();
  }

  componentDidMount() {
    const { fetchBidSession } = this.props;
    const staffId = getStaffId();
    const applyStandingBid = JSON.parse(sessionStorage.getItem(LOADSTANDING_KEY)) || false;
    fetchBidSession(staffId, this.state.bidSessionId, applyStandingBid, false);

    // Listen for bid scope changes
    window.addEventListener('lastBidScopeUsedChanged', this.handleBidScopeChange);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.params.bidId !== nextProps.params.bidId) {
      const { fetchBidSession } = this.props;
      const staffId = getStaffId();
      fetchBidSession(staffId, nextProps.params.bidId, nextProps.bidSession.user.loadStanding, false);
    }
    if (!nextProps.isFetching && this.state.preferenceAdded) {
      this.setState({ preferenceAdded: false });
    }

    /*
    Set the bid preferences stored in Redux just one time
    during the first load
    */
    const bidPreferences = nextProps.bidSession.bidPreferences;

    if (
      bidPreferences &&
      bidPreferences.errorMessage &&
      this.state.isDisplayedErrorMessage === false
    ) {
      this.setBidPreferences(bidPreferences);
      this.firstLoad = false;
      this.showNotification(bidPreferences.errorMessage);
      this.setState({ isDisplayedErrorMessage: true });
      return;
    }
    if (this.state.standingBidAppliedReserveLinetype === true) {
      bidSessionActions.default
        .getReserveLineType(
          this.state.bidSessionId,
          getStaffId(),
          nextProps.bidSession.user.currentCategory.categoryId
        )()
        .then(response => {
          const bidSession = {
            ...nextProps.bidSession,
            reserveLine: {
              ...nextProps.bidSession.reserveLine,
              bidderReserveLines: response.data.bidderReserveLines
            }
          };
          this.setState({ bidSessionData: bidSession });
        });
    }

    if (
      !this.state.bidPreferences.totalEntries &&
      bidPreferences &&
      this.state.applyStandingBidsSelected === true
    ) {
      // Update otherOptions from Redux to reflect imported waivers
      this.setState({
        applyStandingBidsSelected: false,
        loadingBidTable: false,
        otherOptions: nextProps.bidSession.otherOptions
      });
      this.setBidPreferences(bidPreferences);
      if (bidPreferences.message) {
        this.showNotification(bidPreferences.message);
      }
      return;
    }
    if (nextProps.bidSession?.reserveLine?.message != null && !this.reserveLineMessageShown) {
      this.showReserveLineAlertDialog(nextProps.bidSession?.reserveLine?.message);
      this.reserveLineMessageShown = true;
    }

    if (!this.state.bidPreferences.totalEntries && this.firstLoad) {
      if (bidPreferences) {
        this.firstLoad = false;
        const loadStandingMessage = bidPreferences
          ? bidPreferences.decisionMessage
          : '';
        if ((!bidPreferences.totalEntries ||
          (bidPreferences.totalEntries &&
            bidPreferences.totalEntries === 0)) &&
          loadStandingMessage &&
          loadStandingMessage.length > 0
        ) {
          this.fetchPreviousBidSessionsAndShowDialog(loadStandingMessage, nextProps.bidSession);
        }
      }
      this.setBidPreferences(bidPreferences || {});
      if (bidPreferences && bidPreferences.message) {
        this.showNotification(bidPreferences.message);
      }
    }
    if (
      bidPreferences &&
      bidPreferences.totalEntries &&
      bidPreferences.totalEntries > 0
    ) {
      this.setBidPreferences(bidPreferences || {});
    }
  }

  componentDidUpdate(prevProps) {
    // Scroll to bottom the bid preferences list when a new preference is added
    if (this.state.preferenceAdded) {
      const target = document.getElementsByClassName('rows-container')[0];
      if (target) {
        target.scrollTop = target.scrollHeight;
      }
    }
  }

  componentWillUnmount() {
    this.props.clearData();
    // Clean up event listener
    window.removeEventListener('lastBidScopeUsedChanged', this.handleBidScopeChange);
  }

  setBidPreferences = bidPreferences => this.setState({ bidPreferences });
  getBidPreferencesTotalEntries = () => {
    const bidPreferencesTotalEntries =
      this.state.bidPreferences.totalEntries || 0;
    return bidPreferencesTotalEntries;
  };

  handleBidScopeChange = () => {
    // Update the current bid scope state when it changes
    this.setState({ currentBidScope: getLastBidScopeUsedString() });
  };

  handleActionPreference = (response, newPreferenceAdded = false) => {
    if (this.isResponseStatusOKorInternalServerError(response)) {
      this.preferenceHasChange = !this.preferenceHasChange;
      const prefs =
        response.status === httpStatus.OK
          ? response.data.preferences
          : this.state.bidPreferences.entries;
      const bidPreferences = orderPreferences(prefs);
      this.setState(state => ({
        ...state,
        preferenceAdded: newPreferenceAdded,
        bidPreferences: {
          start: 0,
          end: bidPreferences.length - 1,
          totalEntries: bidPreferences.length,
          entries: bidPreferences
        }
      }));
    }
  };

  handleMovePreference = (type, oldScore, isCombined) => {
    const preferencesToCheck = processPreferences(
      type,
      oldScore,
      this.state.bidPreferences.entries,
      this.showNotification
    );

    if (!preferencesToCheck) return;

    this.setState({ loadingBidTable: true });
    const { switchPriority } = this.props;
    const { bidAggregateIds, bidAggregateIdsToSwitchWith } = movePreference(
      type,
      oldScore,
      preferencesToCheck,
      isCombined
    );

    switchPriority(bidAggregateIds, bidAggregateIdsToSwitchWith)
      .then(response => {
        if (response && response.status === httpStatus.OK) {
          const bidPreferences = sortPreferences(response.data.preferences);
          this.preferenceHasChange = !this.preferenceHasChange;
          this.setState({
            loadingBidTable: false,
            bidPreferences: {
              start: 0,
              end: bidPreferences.length - 1,
              totalEntries: bidPreferences.length,
              entries: bidPreferences
            }
          });
        } else {
          // Reset loading state even if response is not OK
          this.setState({ loadingBidTable: false });
        }
      })
      .catch(e => {
        // Reset loading state on error to prevent UI from being stuck
        this.setState({ loadingBidTable: false });
      });
  };

  handleWeightEdit = (preference, weight, bidmode) => {
    const { bidPreferences } = this.state;
    const bidId = preference.bidAggregateId;
    bidSessionUpdateWeight(
      this,
      bidPreferences,
      bidId,
      weight,
      preference,
      bidmode
    );
  };
  handleClose = () => {
    this.setState(state => ({ ...state, open: false }));
  };
  isResponseStatusOKorInternalServerError = response => {
    return (
      response &&
      (response.status === httpStatus.OK ||
        response.status === httpStatus.INTERNAL_SERVER_ERROR)
    );
  };
  showNotification = message => {
    this.setState({
      statusDisplay: true,
      statusDisplayText: message
    });
  };
  closeStatusDisplay = () => {
    this.setState({
      statusDisplay: false,
      statusDisplayText: ''
    });
  };
  showAlertDialog = message => {
    this.setState({
      alertDialogDisplay: true,
      alertDialogDisplayText: message,
      isReserveLineAlert: false,
      applyStandingBidsSelected: false
    });
  };

  fetchPreviousBidSessionsAndShowDialog = (message, bidSessionProps = null) => {
    // Use passed bidSession or fallback to current props
    const bidSession = bidSessionProps || this.props.bidSession;
    const staffId = getStaffId();
    const bidSessionId = this.state.bidSessionId;
    const categoryId = bidSession.user?.currentCategory?.categoryId;

    // Get labels from context with fallback
    const { labels } = this.context || {};
    const APPLICATION_TYPE = labels?.commonLabels?.APPLICATION_TYPE || 'REGULAR';

    this.setState({
      loadingPreviousBidSessions: true,
      alertDialogDisplay: true,
      alertDialogDisplayText: message,
      applyStandingBidsSelected: false
    });

    fetchPreviousBidSession(staffId, categoryId, BID_TYPES.REGULAR, APPLICATION_TYPE, bidSessionId, true)()
      .then(response => {
        if (response && response.data) {
          this.setState({
            previousBidSessions: response.data || [],
            loadingPreviousBidSessions: false
          });
        } else {
          this.setState({
            previousBidSessions: [],
            loadingPreviousBidSessions: false
          });
        }
      })
      .catch(error => {
        this.setState({
          previousBidSessions: [],
          loadingPreviousBidSessions: false
        });
      });
  };
  closeAlertDialog = () => {
    this.setState({
      alertDialogDisplay: false,
      alertDialogDisplayText: '',
      applyStandingBidsSelected: false,
      // Reset BidSessionsList state
      alertDialogSelectedBidSessionId: null,
      alertDialogBidPreferences: [],
      alertDialogCombinedGroups: [],
      alertDialogSelectedCombinedPreferencesId: '',
      alertDialogSelectedGroupId: null,
      alertDialogGroupPreferences: [],
      alertDialogReserveLineNames: '',
      previousBidSessions: [],
      loadingPreviousBidSessions: false,
      selectedBidSessionImportable: true,
    });
  };

  showReserveLineAlertDialog = message => {
    this.setState({
      reserveLineAlertDisplay: true,
      reserveLineAlertText: message
    });
  };

  closeReserveLineAlertDialog = () => {
    const TRANSITION_DURATION = 600;
    
    this.setState({ isTransitioningDialogs: true });
    
    this.transitionTimeout = setTimeout(() => {
      this.setState({
        reserveLineAlertDisplay: false,
        reserveLineAlertText: '',
        isTransitioningDialogs: false
      });
    }, TRANSITION_DURATION);
  };
  // Handle BidSessionsList interactions in AlertDialog
  handleAlertDialogBidSessionSelect = (bidSessionId) => {
    // Check if clicking on already selected bid session (to collapse)
    if (this.state.alertDialogSelectedBidSessionId === bidSessionId) {
      this.setState({
        alertDialogSelectedBidSessionId: null,
        alertDialogBidPreferences: [],
        alertDialogSelectedCombinedPreferencesId: '',
        alertDialogCombinedGroups: [],
        alertDialogSelectedGroupId: null,
        alertDialogGroupPreferences: [],
        alertDialogReserveLineNames: '',
        selectedBidSessionImportable: true,
      });
    } else {
      // Expand the selected bid session
      const bidSession = this.state.previousBidSessions.find(session => session.bidSessionId === bidSessionId);
      if (bidSession) {
        // Extract and format reserve line names - using the same logic as ImportPreferencesDialog
        const reserveLineNames = (bidSession.reserveLineDto || [])
          .map(line => line.name)
          .filter(Boolean)
          .join(', ');

        this.setState({
          alertDialogSelectedBidSessionId: bidSessionId,
          alertDialogBidPreferences: bidSession.bidDtos || [],
          alertDialogSelectedCombinedPreferencesId: '',
          alertDialogCombinedGroups: [],
          alertDialogSelectedGroupId: null,
          alertDialogGroupPreferences: [],
          alertDialogReserveLineNames: reserveLineNames,
          selectedBidSessionImportable: bidSession.importable || false,
        });
      }
    }
  };

  handleAlertDialogCombinedSelect = (combinedId) => {
    if (this.state.alertDialogSelectedCombinedPreferencesId === combinedId) {
      this.setState({
        alertDialogSelectedCombinedPreferencesId: '',
        alertDialogGroupPreferences: [],
        alertDialogCombinedGroups: [],
        alertDialogSelectedGroupId: null,
      });
    } else {
      const combinedGroups = groupByGroupSequence(
        this.state.alertDialogBidPreferences.filter(pref => pref.groupName === combinedId)
      );
      this.setState({
        alertDialogSelectedCombinedPreferencesId: combinedId,
        alertDialogCombinedGroups: combinedGroups,
        alertDialogSelectedGroupId: null,
        alertDialogGroupPreferences: [],
      });
    }
  };

  handleAlertDialogGroupSelect = (groupId) => {
    if (this.state.alertDialogSelectedGroupId === groupId) {
      this.setState({
        alertDialogSelectedGroupId: null,
        alertDialogGroupPreferences: [],
      });
    } else {
      const group = this.state.alertDialogCombinedGroups.find(g => g.groupSequence === groupId);
      this.setState({
        alertDialogSelectedGroupId: groupId,
        alertDialogGroupPreferences: group ? group.preferences : [],
      });
    }
  };

  /**
   * Apply standing bids to bid session
   * 1. Fetch bid session to reset bid preferences (includes updated other options/waivers)
   * 2. Update bid session in Redux
   * 3. Force update component to refresh bid table
   * 4. Close alert dialog and loading indicator
   */
  applyStandingBidsToBidSession = () => {
    this.setState({
      alertDialogDisplay: false,
      alertDialogDisplayText: '',
      standingBidAppliedReserveLinetype: true,
      applyStandingBidsSelected: true,
      loadingBidTable: true,
      // Clear local otherOptions state so component uses the updated Redux value
      otherOptions: null
    });

    const staffId = getStaffId();
    const bidSessionId = this.state.bidSessionId;

    const { fetchBidSession } = this.props;
    // fetchBidSession with applyStandingBid=true now fetches updated otherOptions
    // after standing bids are applied, so waivers are enabled immediately
    fetchBidSession(staffId, bidSessionId, true, false);

    // Set loading to false after a brief delay to allow Redux state to update
    setTimeout(() => {
      this.setState({ loadingBidTable: false });
    }, 500);
  };

  removeActivities = () => {
    const { updateCalendar } = this.props;
    const activities = this.props.activities.activities;
    const types = this.props.activities.types;
    let newEntries = activities.entries;
    newEntries = activities.entries.filter(activity => !activity.addedByUser);
    updateCalendar({
      activities: {
        entries: newEntries,
        end: newEntries.length,
        totalEntries: newEntries.length
      },
      types
    });

    // Get labels from context with fallback
    const { labels } = this.context || {};
    const linearCalendarLabels = labels?.linearCalendar;
    this.showNotification(linearCalendarLabels?.MESSAGES?.REMOVE_SUCCESS);
  };
  checkLegality = () => {
    const activities = this.props.activities.activities.entries;
    const addedActivities = activities.filter(activity => activity.addedByUser);
    const activitiesIds = addedActivities.map(activity => activity.activityId);

    if (!activitiesIds.length) {
      // Get labels from context with fallback
      const { labels } = this.context || {};
      const legalityCheckLabels = labels?.legalityCheck;
      this.showNotification(legalityCheckLabels?.MESSAGES?.NO_ACTIVITIES?.MESSAGE);
      return;
    }
    const { bidSession } = this.props;
    const bidSessionId = bidSession.currentBid.bidSessionId;
    const currentCategory = bidSession.user.currentCategory || {};
    const categoryId = currentCategory.categoryId;
    const staffId = bidSession.user.staffId;

    this.setState(state => ({
      ...state,
      open: true,
      activitiesIds,
      bidSessionId,
      categoryId,
      staffId
    }));
  };
  requestAll = () => {
    const ADDING_BID = this.props.labels?.ADDING_BID || {};
    const legalityCheck = this.props.labels?.legalityCheck || {};
    const activities = this.props.activities.activities;
    const activityEntries = activities.entries ? activities.entries : [];
    let bidSession = this.props.bidSession;
    const activityArray = [];
    const bidInfoDtos = [];
    const bidMode = getBidMode();
    const updateNextAvailableLevel = () => {
      if (bidMode !== BidMode.LADDER.biddingMode) {
        return;
      }
      const tempBidPreferences = this.state.bidPreferences;
      tempBidPreferences.entries = [
        ...this.state.bidPreferences.entries,
        ...bidInfoDtos
      ];
      const nextAvailableLevel =
        bidSessionActions.default.getNextAvailableLevel(
          tempBidPreferences,
          this.props.bidSession.bidLevels,
          this.props.bidSession.allowDuplicates
        );
      this.props.bidSession.nextAvailableLevel = nextAvailableLevel;
    };
    let staffId;
    updateNextAvailableLevel();
    activityEntries.forEach(activityEntry => {
      const currentCategory = bidSession.user.currentCategory || {};
      const startDayOffset = currentCategory.startDayOffset;
      staffId = bidSession.user.staffId;
      const currentBid = bidSession.currentBid ? bidSession.currentBid : {};
      const StartDateUTCStr = utils.arrayDateToUtcString(
        currentBid.startDate,
        startDayOffset
      );
      const EndDateUTCStr = utils.arrayDateToUtcString(
        currentBid.endDate,
        startDayOffset
      );
      bidSession = {
        ...bidSession,
        startDateUTCStr: StartDateUTCStr,
        endDateUTCStr: EndDateUTCStr
      };
      const { isPairingOrReserve, isPreferenceOptionActive } =
        buildAddRequestData(activityEntry, bidSession);
      const isActivityStartInSessionPeriod = isActivityStartsInBidSessionPeriod(
        activityEntry,
        bidSession
      );

      if (
        isPairingOrReserve &&
        isActivityStartInSessionPeriod &&
        isPreferenceOptionActive
      ) {
        activityArray.push(activityEntry);
      }
    });

    let score = '';
    if (bidSession.bidMode === BidMode.MANUAL.biddingMode) {
      score = BidMode.MANUAL.changedWeight;
    } else if (bidSession.bidMode === BidMode.LADDER.biddingMode) {
      score = this.props.bidSession.nextAvailableLevel;
    } else {
      score = this.state.bidPreferences.totalEntries;
    }

    let preferenceOptionId = null;
    let parameterValues = [];
    let wish = Boolean;
    let bidPreference;
    if (activityArray.length < 1) {
      this.showNotification(legalityCheck.MESSAGES.NO_ADDED_ACTIVITIES.MESSAGE);
      return;
    }

    this.setState(state => ({ ...state, requestAll: true }));
    
    // Determine which preference option IDs to use based on what's available
    const activePreferenceOptionsIds = bidSession.activePreferenceOptionsIds || [];
    const pairingPreferenceOptionId = [KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES, KINDOFBID.PAIRING_START_ON_DATE].find(id => activePreferenceOptionsIds.includes(id)) || null;
    
    activityArray.forEach(item => {
      const activityStartDateString = utils.formatActivityDate(
        utils.getUTC(item.startDate)
      );
      wish = true;
      
      // Use determined preference option ID for pairings, 760 for reserves
      if (item.type === openTimeSearchConfig.activityTypes.TRP) {
        if (!pairingPreferenceOptionId) {
          // Skip this pairing if no valid preference option is available
          return;
        }
        preferenceOptionId = pairingPreferenceOptionId;
      } else {
        preferenceOptionId = 760; // Reserve
      }
      
      if (
        bidSession.bidMode !== BidMode.MANUAL.biddingMode &&
        bidSession.bidMode !== BidMode.LADDER.biddingMode &&
        bidSession.bidMode !== BidMode.AUTOMATIC.biddingMode
      ) {
        score++;
      } else {
        if (bidMode === BidMode.AUTOMATIC.biddingMode) {
          score = BidMode.AUTOMATIC.changedWeight;
        } else if (bidMode === BidMode.LADDER.biddingMode) {
          updateNextAvailableLevel();
          score = this.props.bidSession.nextAvailableLevel;
        } else if (bidMode === BidMode.MANUAL.biddingMode) {
          score = BidMode.MANUAL.changedWeight;
        }
      }
      if (item.type === openTimeSearchConfig.activityTypes.TRP) {
        let activityStartDate = activityStartDateString.replace(/\n/g, '');
        activityStartDate = activityStartDate.replace(/\s{2,10}/g, ' ');
        
        // Build parameter values based on which preference option ID is being used
        if (preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
          // ID 784: SPECIFIC_PAIRING_STARTING_ON_DATES (3 parameters)
          parameterValues = [
            {
              parameterRelation: 'EQUAL_RELATION_CODE',
              parameterId: 7841,
              value: item.name,
              parameterSequence: 1
            },
            {
              parameterRelation: 'EQUAL_RELATION_CODE',
              parameterId: 7842,
              value: activityStartDate.substring(0, 10),
              parameterSequence: 2
            },
            {
              parameterRelation: 'EQUAL_RELATION_CODE',
              parameterId: 7843,
              value: activityStartDate.substring(0, 10),
              parameterSequence: 3
            }
          ];
        } else {
          // ID 132: PAIRING_START_ON_DATE (2 parameters)
          parameterValues = [
            {
              parameterRelation: 'EQUAL_RELATION_CODE',
              parameterId: 1321,
              value: item.name,
              parameterSequence: 1
            },
            {
              parameterRelation: 'EQUAL_RELATION_CODE',
              parameterId: 1322,
              value: activityStartDate.substring(0, 10), // removed new Date() function as the date is being already formatted to UTC, and keeing the date as it is displayed
              parameterSequence: 2
            }
          ];
        }
      } else if (item.type === openTimeSearchConfig.activityTypes.RSV) {
        parameterValues = [
          {
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 7601,
            value: item.name,
            parameterSequence: 2
          }
        ];
      }
      bidInfoDtos.push({
        bidSessionId: bidSession.currentBid.bidSessionId,
        preferenceOptionId,
        score,
        parameterValues
      });
    });
    bidPreference = {
      bidSessionId: bidSession.currentBid.bidSessionId,
      staffId,
      preferenceOptionId,
      preferenceOptionPropertyId: 0,
      score,
      parameterValues: [],
      bidInfoDtos,
      wish,
      bidMode: bidMode
    };
    bidSessionActions.default
      .savePreference(bidPreference)()
      .then(response => {
        this.setState(state => ({
          ...state,
          isSaving: false,
          requestAll: false
        }));
        this.showNotification(ADDING_BID.ADD_MESSAGE);
        this.handleActionPreference(response, true);
      })
      .catch(e => {
        this.setState(state => ({
          ...state,
          isSaving: false,
          requestAll: false
        }));
        this.showNotification(e.response.data.message);
      });
  };

  weightSorting = sort => {
    requestWeightSorting(this, sort);
  };

  handleUpdateScoresResponse = response => {
    if (response && response.status === httpStatus.OK) {
      this.preferenceHasChange = !this.preferenceHasChange;
      console.time('handleUpdateScoresResponse-foreach');
      response.data.entries.forEach(responseEntry => {
        const responseScore = responseEntry.score;
        const responseAggregateId = responseEntry.bidAggregateId;
        this.state.bidPreferences.entries.forEach(currentEntry => {
          if (currentEntry.bidAggregateId === responseAggregateId) {
            currentEntry.score = responseScore;
          }
        });
      });
      const bidPreferences = sortPreferences(
        orderPreferences(this.state.bidPreferences.entries)
      );
      this.setState(
        state => ({
          ...state,
          preferenceAdded: false,
          bidPreferences: {
            start: 0,
            end: bidPreferences.length - 1,
            totalEntries: bidPreferences.length,
            entries: bidPreferences
          }
        }),
        () => {
          this.setState({ readOnly: false });
        }
      );
    }
  };
  reOrderReserveLineType = data => {
    const { labels: contextLabels = {} } = this.context || {};
    const { reorderReserveline } = this.props;
    let bidSession = this.props.bidSession;
    const staffId = bidSession.user.staffId;
    const bidSessionId = bidSession.currentBid.bidSessionId;
    const categoryId = bidSession.user.currentCategory.categoryId;
    const RESERVE_LINE_CONTEXT = contextLabels.RESERVE_LINE || {};
    reorderReserveline(staffId, bidSessionId, categoryId, data)
      .then(response => {
        this.setState({ isReserveLineTypeSaveFail: false });
        if (response && response.status === httpStatus.OK) {
          this.setState({
            updatedReserveLineType: response.data.bidderReserveLines
          });
          this.showNotification(RESERVE_LINE_CONTEXT.NOTIFICATION.SUCCESS);
        } else {
          this.setState({ isReserveLineTypeSaveFail: true });
          this.setState({
            updatedReserveLineType: [
              ...bidSession.reserveLine.bidderReserveLines
            ]
          });
          this.showNotification(response?.data?.httpStatus);
        }
        // Call checkBidSessionRequests on BidTable after reorder
        if (this.bidTableRef && this.bidTableRef.current && typeof this.bidTableRef.current.checkBidSessionRequests === 'function') {
          this.bidTableRef.current.checkBidSessionRequests();
        }
      })
      .catch(e => {
        this.setState({ isReserveLineTypeSaveFail: true });
        this.setState({
          updatedReserveLineType: [...bidSession.reserveLine.bidderReserveLines]
        });
        this.showNotification(e?.statusText || e?.response?.statusText);
        // Still call checkBidSessionRequests in case of error
        if (this.bidTableRef && this.bidTableRef.current && typeof this.bidTableRef.current.checkBidSessionRequests === 'function') {
          this.bidTableRef.current.checkBidSessionRequests();
        }
      });
  };

  reorderPreferences = (oldIndex, newIndex) => {
    // get the bid scope to filter the preferences to move
    let lastBidScopeUsed = getLastBidScopeUsed();

    //non-movable Preferences
    let fixedPreferences = this.state.bidPreferences.entries.filter(
      preference =>
        isOptionLevelIsSmallerEqualThanReserve(preference.optionLevel) ||
        !preference.scoreApplicable
    );

    let preferencesToCheck = this.state.bidPreferences.entries.filter(
      preference =>
        preference.preferenceOptionPropertyId === lastBidScopeUsed &&
        preference.optionLevel > RESERVE_DOWN_TO.levelAny &&
        preference.scoreApplicable !== false
    );
    // Adjust indexes for preferencesToCheck
    let preferencesInScope = this.state.bidPreferences.entries.filter(
      preference => preference.preferenceOptionPropertyId === lastBidScopeUsed
    );
    let preferencesNotInScope = this.state.bidPreferences.entries.filter(
      preference => preference.preferenceOptionPropertyId !== lastBidScopeUsed
    );

    const validIndexes = preferencesInScope.reduce((acc, preference, index) => {
      if (preferencesToCheck.includes(preference)) acc.push(index);
      return acc;
    }, []);

    const adjustedOldIndex = validIndexes.indexOf(oldIndex);
    const adjustedNewIndex = validIndexes.indexOf(newIndex);

    if (adjustedOldIndex === -1 || adjustedNewIndex === -1) return;
    // Move only allowed preferences
    let updatePrefs = moveItem(
      preferencesToCheck,
      adjustedOldIndex,
      adjustedNewIndex
    );
    this.setState({
      bidPreferences: {
        entries: [...fixedPreferences, ...updatePrefs, ...preferencesNotInScope]
      }
    });

    const prevState = { ...this.state };
    const { updateAllScores } = this.props;
    this.setState(
      {
        readOnly: true,
        loadingBidTable: true
      },
      () => {
        updateAllScores(updatePrefs)
          .then(response => {
            if (response && response.status === httpStatus.OK) {
              this.preferenceHasChange = !this.preferenceHasChange;
              this.handleUpdateScoresResponse(response);
              this.setState({ loadingBidTable: false });
            }
          })
          .catch(() => {
            this.setState({ ...prevState });
          });
      }
    );
  };

  copyPreference = (employeeBidId, groupName) => {
    const { fetchBidSession } = this.props;
    this.setState({ loadingBidTable: true });
    this.props
      .copyCombinedPreference(employeeBidId, groupName)
      .then(response => {
        if (response.data.errorMessages && response.status !== httpStatus.OK) {
          this.setState({
            loadingBidTable: false,
            isDisplayedErrorMessage: true
          });
          const newArr = Object.values(response.data.errorMessages);
          const mappedArr = newArr.map(i => i);
          this.showNotification(mappedArr);
          return;
        } else {
          const bidPreferences = response?.data?.preferences;
          this.setState({
            loadingBidTable: false,
            bidPreferences: bidPreferences,
            isDisplayedErrorMessage: false
          });
          fetchBidSession(
            getStaffId(),
            this.state.bidSessionId,
            undefined,
            false
          );
        }
      })
      .catch(error => {
        this.setState({ loadingBidTable: false });
      });
  };

  handlePreferencesCleared = () => {
    const { bidSession } = this.props;
    const staffId = bidSession.user.staffId;
    const bidSessionId = bidSession.currentBid.bidSessionId;
    const categoryId = bidSession.user.currentCategory.categoryId;

    this.props.fetchOtherOptions(staffId, bidSessionId, categoryId)
      .then(res => {
        const newOptions = res?.data || { entries: [] };
        this.setState({ otherOptions: newOptions });

        const updatedBidSession = {
          ...this.props.bidSession,
          otherOptions: newOptions
        };
        this.props.updateBidSession(updatedBidSession);
      });
  };

  handleOtherOptionToggled = (otherOptionCode, newValue) => {
    // Update the local otherOptions state to reflect the toggle
    const currentOptions = this.state.otherOptions
      || this.props.bidSession.otherOptions
      || { entries: [] };

    const updatedEntries = currentOptions.entries.map(opt =>
      opt.otherOptionCode === otherOptionCode
        ? { ...opt, value: newValue }
        : opt
    );

    const newOptions = { ...currentOptions, entries: updatedEntries };
    this.setState({ otherOptions: newOptions });

    // Update bidSession to trigger BidTable's componentDidUpdate
    const updatedBidSession = {
      ...this.props.bidSession,
      otherOptions: newOptions
    };
    this.props.updateBidSession(updatedBidSession);

    // Call checkBidSessionRequests on BidTable after waiver toggle
    if (this.bidTableRef && this.bidTableRef.current && typeof this.bidTableRef.current.checkBidSessionRequests === 'function') {
      this.bidTableRef.current.checkBidSessionRequests();
    }
  };

  render() {
    const { labels } = this.context || {};
    const { updateOtherOption, fetchActivities, match, fetchOtherOptions, fetchBidPreferences } = this.props;

    // Use context labels with fallbacks to props
    const BID_TABLE_PROPS = this.props.labels?.BID_TABLE || labels?.BID_TABLE;
    const commonLabels_PROPS = this.props.labels?.commonLabels || labels?.commonLabels;
    const linearCalendar_PROPS = this.props.labels?.linearCalendar || labels?.linearCalendar;
    const IMPORT_PREVIOUS_BID_PROPS = this.props.labels?.IMPORT_PREVIOUS_BID || labels?.IMPORT_PREVIOUS_BID;
    const BID_NAME_PROPS = this.props.labels?.BID_NAME || labels?.BID_NAME || {};
    const REPORT_PROPS = this.props.labels?.REPORT || labels?.REPORT;
    const RESERVE_LINE_PROPS = this.props.labels?.RESERVE_LINE || labels?.RESERVE_LINE;
    const creditLabels_PROPS = this.props.labels?.creditLabels || labels?.creditLabels;
    const calendarLabels_PROPS = this.props.labels?.calendarLabels || labels?.calendarLabels;
    const ALERT_DIALOG_CONTEXT = labels?.ALERT_DIALOG || {};
    const toDate = this.context?.language === 'fr' ? 'au' : 'to';

    let { bidSession } = this.props;
    const currentBid = bidSession.currentBid ? bidSession.currentBid : {};
    const user = bidSession.user || {};
    const isOpen = currentBid.isOpen !== undefined ? currentBid.isOpen : true;

    const initialCredit = user.initialCredit || 0;
    const currentCategory = user.currentCategory || {};
    const categoryId = currentCategory.categoryId;
    const seatId = currentCategory.seatId;
    const otherOptions = this.state.otherOptions
      ? this.state.otherOptions
      : (bidSession.otherOptions ? bidSession.otherOptions : { entries: [] });
    const { isFetching } = this.props;
    const staffId = getStaffId();
    let bidStartDate = new Date(0);
    let bidEndDate = new Date(0);
    const startDayOffset = currentCategory.startDayOffset;
    let bidSessionStartDateUTCStr = null;
    let bidSessionEndDateUTCStr = null;
    let calendarStartDateUTCStr = null;
    let calendarEndDateUTCString = null;
    let bidSessionDays;
    let totalDaysInCalendar;

    if (currentBid.startDate && currentBid.endDate) {
      bidStartDate = new Date(
        currentBid.startDate[0],
        currentBid.startDate[1] - 1,
        currentBid.startDate[2]
      );

      bidEndDate = new Date(
        currentBid.endDate[0],
        currentBid.endDate[1] - 1,
        currentBid.endDate[2]
      );

      bidSessionStartDateUTCStr = utils.arrayDateToUtcString(
        currentBid.startDate,
        startDayOffset
      );
      bidSessionEndDateUTCStr = utils.arrayDateToUtcString(
        currentBid.endDate,
        startDayOffset
      );
      bidSessionDays = utils.getDaysBetweenDates(
        new Date(bidSessionStartDateUTCStr).getTime(),
        new Date(bidSessionEndDateUTCStr).getTime()
      );
      totalDaysInCalendar =
        openBidsBuffer.prevBuffer + bidSessionDays + openBidsBuffer.afterBuffer;
      calendarStartDateUTCStr = utils.getCalendarStartDate(
        bidSessionStartDateUTCStr,
        openBidsBuffer.prevBuffer
      );
      calendarEndDateUTCString = utils.getCalendarEndDate(
        bidSessionEndDateUTCStr,
        openBidsBuffer.afterBuffer
      );
      bidEndDate = utils.removeDays(bidEndDate, 1);

      bidSession = {
        ...bidSession,
        startDateUTCStr: bidSessionStartDateUTCStr,
        endDateUTCStr: bidSessionEndDateUTCStr,
        bidSessionDays
      };
    }
    if (
      (this.state.updatedReserveLineType &&
        this.state.updatedReserveLineType.length !== 0 &&
        JSON.stringify(bidSession?.reserveLine?.bidderReserveLines) !==
        JSON.stringify(this.state.updatedReserveLineType)) ||
      (this.state.isReserveLineTypeSaveFail &&
        this.state.updatedReserveLineType &&
        this.state.updatedReserveLineType.length !== 0)
    ) {
      bidSession = {
        ...bidSession,
        reserveLine: {
          ...bidSession.reserveLine,
          bidderReserveLines: this.state.updatedReserveLineType
        }
      };
    }
    if (
      this.state.standingBidAppliedReserveLinetype &&
      this.state.bidSessionData?.reserveLine?.bidderReserveLines
    ) {
      this.setState({ standingBidAppliedReserveLinetype: false });
      bidSession = {
        ...bidSession,
        reserveLine: {
          ...bidSession.reserveLine,
          bidderReserveLines:
            this.state.bidSessionData?.reserveLine?.bidderReserveLines
        }
      };
    }

    const lastSavedData = bidSession.lastSavedData
      ? bidSession.lastSavedData
      : {};
    const titleStyle = {
      fontSize: '16px'
    };
    const menuOptions = [
      {
        key: 'lgc',
        label: linearCalendar_PROPS.MENU_LABELS.LEGALITY_CHECK,
        func: this.checkLegality
      },
      {
        key: 'rl',
        label: linearCalendar_PROPS.MENU_LABELS.REQUEST_ALL,
        func: this.requestAll,
        disabled: this.state.currentBidScope === RESERVE_BID_SCOPE
      },
      {
        key: 'rmv',
        label: linearCalendar_PROPS.MENU_LABELS.REMOVE_ACTIVITIES,
        func: this.removeActivities
      }
    ];
    const otherOptionSaveBody = {
      staffId,
      bidSessionId: match.params.bidId,
      categoryId,
      startDateSession: bidSessionStartDateUTCStr,
      endDateSession: bidSessionEndDateUTCStr,
      value: null
    };

    const handleOpenReportDialog = () =>
      this.setState({ openReportDialog: !this.state.openReportDialog });

    const handleOpenImportDialog = () =>
      this.setState({ openImportDialog: !this.state.openImportDialog });

    /**
     * Handle import previous bid preferences
     * 1. Call importPreviousBidPreferences action
     * 2. Update local state with new bid preferences and other options
     * 3. Update Redux store with new other options
     * 4. Show notification
     * @param {*} staffId - Staff ID
     * @param {*} currentBidSessionId - Current Bid Session ID
     * @param {*} previousBidSessionId - Previous Bid Session ID
     * @param {*} bidPreferences - Bid Preferences to import
     */
    const handleImportPreviousBidPreferences = (
      staffId,
      currentBidSessionId,
      previousBidSessionId,
      bidPreferences
    ) => {
      this.setState({ loadingImportPreviousBids: true });
      this.props
        .importPreviousBidPreferences(
          staffId,
          currentBidSessionId,
          previousBidSessionId,
          bidPreferences
        )
        .then(response => {
          if (response && response.status === httpStatus.OK) {
            const preferences = sortPreferences(
              orderPreferences(response.data.bidDtos)
            );
            const newOtherOptions = { entries: response.data.otherOptionDtos || [] };

            // Update local state
            this.setState({
              loadingImportPreviousBids: false,
              openImportDialog: false,
              bidPreferences: { entries: preferences },
              otherOptions: newOtherOptions
            });
            // Update Redux store
            const updatedBidSession = {
              ...this.props.bidSession,
              otherOptions: newOtherOptions
            };
            this.props.updateBidSession(updatedBidSession);

            this.showNotification(
              IMPORT_PREVIOUS_BID.SUCCESS,
              IMPORT_PREVIOUS_BID.IMPORT_SUCCESS_MESSAGE,
              'success'
            );
          } else {
            this.setState({
              loadingImportPreviousBids: false,
              openImportDialog: false
            });
            this.showNotification(IMPORT_PREVIOUS_BID.ERROR, 'error');
          }
        })
        .catch(e => {
          this.setState({
            loadingImportPreviousBids: false,
            openImportDialog: false
          });
          this.showNotification(IMPORT_PREVIOUS_BID.ERROR, 'error');
        });
    };




    const closedBadge = !isOpen ? (
      <div className="closed-badge-wrapper">
        <div className="closed-badge-separator" />
        <div className="closed-badge-content">
          <svg width="20" height="20" viewBox="0 0 24 24">
            <circle 
              cx="12" 
              cy="12" 
              r="10" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2.5"
            />
            <line 
              x1="5" 
              y1="5" 
              x2="19" 
              y2="19" 
              stroke="currentColor" 
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
          <span>CLOSED</span>
        </div>
      </div>
    ) : null;

    const titleWithBadge = (
      <span className="title-with-badge">
        {`${currentBid.name ? currentBid.name : ''} Session`}
        {closedBadge}
      </span>
    );

    return (
      <div>
        {isFetching ? (
          <Loader />
        ) : (
          <MainCardContainer
            headTitle={titleWithBadge}
            headSubtitle={`${commonLabels_PROPS.LAST_SAVED_REQUESTS} ${getDateStr(
              lastSavedData.lastSave
            )}`}
            hasMenu={false}
            headClassName='large-11 medium-11 small-11 columns'
            content={[
              <CardRow
                key={`cardRow-${0}`}
                cardNumber={1}
                cards={[
                  <Button onClick={handleOpenReportDialog}>
                    {REPORT_PROPS.BUTTON}
                  </Button>,
                  <Button onClick={handleOpenImportDialog}>
                    {IMPORT_PREVIOUS_BID_PROPS.BUTTON}
                  </Button>
                ]}
              />,
              <CardRow
                key={`cardRow-${1}`}
                cardNumber={1}
                cards={[<EmployeeStatistics key={0} user={user} />]}
              />,
              <CardRow
                key={`cardRow-${2}`}
                cardNumber={1}
                cards={[
                  <BidTable
                    key={`BidTable-${1}`}
                    ref={this.bidTableRef}
                    bidSession={{
                      ...bidSession,
                      bidPreferences: this.state.bidPreferences,
                      filteredBidPreferences: JSON.parse(
                        JSON.stringify(this.state.bidPreferences)
                      )
                    }}
                    onPreferencesCleared={this.handlePreferencesCleared}
                    handleActionPreference={this.handleActionPreference}
                    handleMovePreference={this.handleMovePreference}
                    title={BID_TABLE_PROPS.CARD_TITLE}
                    subtitle={BID_TABLE_PROPS.CARD_SUBTITLE}
                    listTitle={BID_TABLE_PROPS.LIST_TITLE}
                    reorderPreferences={this.reorderPreferences}
                    readOnly={this.state.readOnly}
                    handleWeightEdit={this.handleWeightEdit}
                    weightSorting={this.weightSorting}
                    showNotification={this.showNotification}
                    updateWeight={this.props.updateWeight}
                    updateWeightAll={this.props.updateWeightAll}
                    updateBidSession={this.props.updateBidSession}
                    requestAll={this.state.requestAll}
                    reorderReserveline={this.reOrderReserveLineType}
                    isReserveLineTypeSaveFailed={
                      this.state.isReserveLineTypeSaveFail
                    }
                    defaultSettings={false}
                    loadingBidTable={this.state.loadingBidTable}
                    copyCombinedPreference={this.copyPreference}
                    handleImportPreviousBidPreferences={
                      handleImportPreviousBidPreferences
                    }
                    loadingImportPreviousBids={
                      this.state.loadingImportPreviousBids
                    }
                    handleOpenImportDialog={handleOpenImportDialog}
                    openImportDialog={this.state.openImportDialog}
                  />
                ]}
              />,
              <CardRow
                key={`cardRow-${3}`}
                cardNumber={1}
                cards={[
                  <OtherOptions
                    key={0}
                    otherOptions={otherOptions}
                    updateOtherOption={updateOtherOption}
                    otherOptionSaveBody={otherOptionSaveBody}
                    showNotification={this.showNotification}
                    fetchActivities={fetchActivities}
                    calendarStartDateStr={calendarStartDateUTCStr}
                    calendarEndDateStr={calendarEndDateUTCString}
                    onOptionToggled={this.handleOtherOptionToggled}
                  />
                ]}
              />,
              <EmployeeStatistic
                style={{
                  margin: '1em 1em -1em 1em',
                  width: 'calc(100% - 30px)'
                }}
                key={`cardRow-${8}`}
                header={creditLabels_PROPS?.TOTAL}
                data={getTotalCredits(
                  initialCredit,
                  this.props.activities.activities
                )}
              />,
              this.state.open && (
                <LegalityCheck
                  activitiesIds={this.state.activitiesIds}
                  bidSessionId={this.state.bidSessionId}
                  categoryId={this.state.categoryId}
                  handleClose={this.handleClose}
                  key={`cardRow-${4}`}
                  showNotification={this.showNotification}
                  staffId={this.state.staffId}
                />
              ),

              <CardRow
                key={`cardRow-${5}`}
                cardNumber={1}
                cards={[
                  <LinearCalendar
                    bidSession={{
                      ...bidSession,
                      bidPreferences: this.state.bidPreferences
                    }}
                    showNotification={this.showNotification}
                    totalEntries={this.state.bidPreferences.totalEntries}
                    key={`LinearCalendar-${1}`}
                    startDate={currentBid.startDate}
                    endDate={currentBid.endDate}
                    bidPreferencesTotalEntries={
                      this.getBidPreferencesTotalEntries
                    }
                    handleActionPreference={this.handleActionPreference}
                    bidSessionId={this.state.bidSessionId}
                    preferenceHasChange={this.preferenceHasChange}
                    calendarStartDateStr={calendarStartDateUTCStr}
                    calendarEndDateStr={calendarEndDateUTCString}
                    totalDaysInCalendar={totalDaysInCalendar}
                    otherOptions={otherOptions}
                    updateOtherOption={updateOtherOption}
                    otherOptionSaveBody={otherOptionSaveBody}
                    seatId={seatId}
                    fetchActivities={fetchActivities}
                    head={
                      <CardHead
                        hasMenu
                        options={menuOptions}
                        title={`${commonLabels_PROPS?.dates?.months[bidStartDate.getMonth()]
                          }
                         ${bidStartDate.getDate()} ${toDate}
                         ${commonLabels_PROPS?.dates?.months[bidEndDate.getMonth()]}
                         ${bidEndDate.getDate()}
                         ${calendarLabels_PROPS?.BID_SESSION_CALENDAR}`}
                        titleStyle={titleStyle}
                        subtitle={calendarLabels_PROPS?.SUBTITLE}
                        headClassName='card-title'
                      />
                    }
                    requestAll={this.state.requestAll}
                  />
                ]}
              />
            ]}
          />
        )}
        <Notification
          open={this.state.statusDisplay}
          message={this.state.statusDisplayText}
          closeStatusDisplay={this.closeStatusDisplay}
        />
        {/* Import Default Bids Alert Dialog */}
        <AlertDialog
          openAlertDialog={this.state.alertDialogDisplay}
          alertDialogMessage={this.state.alertDialogDisplayText}
          handleOk={this.applyStandingBidsToBidSession}
          handleCancel={this.closeAlertDialog}
          okButtonLabel={ALERT_DIALOG_CONTEXT.APPLY_DEFAULTS_AGREE}
          cancelButtonLabel={ALERT_DIALOG_CONTEXT.APPLY_DEFAULTS_DISAGREE}
          disabled={this.state.previousBidSessions.length > 0 ? !this.state.previousBidSessions[0].importable : false}
          isBackground={this.state.reserveLineAlertDisplay && !this.state.isTransitioningDialogs}
          isFadingOut={false}
          style={{ zIndex: 9999 }}  // Lower z-index when in background
          hasOtherModals={this.state.reserveLineAlertDisplay && !this.state.isTransitioningDialogs}  
        >
          {(this.state.loadingPreviousBidSessions || this.state.previousBidSessions.length > 0) && (
            <BidSessionsList
              loading={this.state.loadingPreviousBidSessions}
              bidSessions={this.state.previousBidSessions}
              selectedBidSessionId={this.state.alertDialogSelectedBidSessionId}
              bidPreferences={this.state.alertDialogBidPreferences}
              combinedGroups={this.state.alertDialogCombinedGroups}
              selectedCombinedPreferencesId={this.state.alertDialogSelectedCombinedPreferencesId}
              selectedGroupId={this.state.alertDialogSelectedGroupId}
              groupPreferences={this.state.alertDialogGroupPreferences}
              reserveLineNames={this.state.alertDialogReserveLineNames}
              loadingSmall={false}
              loadingImportPreviousBids={false}
              forceExpandable={true}
              onSelectBidSession={this.handleAlertDialogBidSessionSelect}
              onSelectCombined={this.handleAlertDialogCombinedSelect}
              onSelectGroup={this.handleAlertDialogGroupSelect}
            />
          )}
        </AlertDialog>

        {/* Reserve Line Alert Dialog */}
        <AlertDialog
          openAlertDialog={this.state.reserveLineAlertDisplay}
          alertDialogMessage={this.state.reserveLineAlertText}
          alertDialogTitle={ALERT_DIALOG_CONTEXT.WARNING}
          handleOk={this.closeReserveLineAlertDialog}
          handleCancel={this.closeReserveLineAlertDialog}
          okButtonLabel={ALERT_DIALOG_CONTEXT.OK}
          cancelButtonLabel={null}
          isFadingOut={this.state.isTransitioningDialogs}
          style={{ zIndex: 10000 }}  // Higher z-index for top dialog
          hasOtherModals={this.state.alertDialogDisplay}  // ADD THIS LINE
        />

        <ReportDialog
          openDialog={this.state.openReportDialog}
          handleOpen={handleOpenReportDialog}
          user={bidSession?.user}
          bidSessionId={currentBid?.bidSessionId}
          bidName={currentBid.name}
          dialogTitle={`${currentBid.name ? currentBid.name : ''
            } Session Report`}
          preferences={this.state.bidPreferences?.entries}
          fetchOtherOptions={fetchOtherOptions}
          fetchBidPreferences={fetchBidPreferences}
        >
          <LinearCalendarTable
            bidSession={bidSession}
            totalEntries={this.state.bidPreferences.totalEntries}
            handleActionPreference={this.handleActionPreference}
            startDate={currentBid.startDate}
            endDate={currentBid.endDate}
            showNotification={this.showNotification}
            calendarStartDateStr={calendarStartDateUTCStr}
            calendarEndDateStr={calendarEndDateUTCString}
            totalDaysInCalendar={totalDaysInCalendar}
            bidPreferencesTotalEntries={this.getBidPreferencesTotalEntries}
            requestAll={this.state.requestAll}
            reportMode
          />
        </ReportDialog>
      </div>
    );
  }
}

BidSession.defaultProps = {
  bidSession: {
    user: {},
    bidPreferences: {}
  },
  params: {
    bidId: ''
  },
  fetchBidSession: () => { },
  mockFetchBidSession: () => { },
  isFetching: false,
  switchPriority: () => { },
  updateAllScores: () => { },
  updateWeight: () => { },
  updateWeightAll: () => { },
  updateBidSession: () => { },
  reorderReserveline: () => { },
  copyCombinedPreference: () => { },
  fetchOtherOptions: () => { }
};

BidSession.propTypes = {
  activities: PropTypes.object.isRequired,
  bidSession: PropTypes.object.isRequired,
  params: PropTypes.shape({
    bidId: PropTypes.string
  }),
  fetchBidSession: PropTypes.func,
  isFetching: PropTypes.bool,
  switchPriority: PropTypes.func,
  updateAllScores: PropTypes.func,
  updateWeight: PropTypes.func,
  updateWeightAll: PropTypes.func,
  updateCalendar: PropTypes.func.isRequired,
  updateOtherOption: PropTypes.func.isRequired,
  fetchActivities: PropTypes.func.isRequired,
  updateBidSession: PropTypes.func.isRequired,
  reorderReserveline: PropTypes.func,
  copyCombinedPreference: PropTypes.func.isRequired,
  fetchOtherOptions: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  ...state.bidSession,
  ...state.linearCalendar,
  ...state.calendarActivities
});

const mapDispatchToProps = dispatch => ({
  clearData: () => dispatch(bidSessionActions.default.clearData()),
  fetchBidSession: (staffId, bidId, applyStandingBid, defaultBid) =>
    dispatch(
      bidSessionActions.default.fetchBidSession(
        staffId,
        bidId,
        applyStandingBid,
        defaultBid
      )
    ),
  switchPriority: (type, oldScore, bidSession) =>
    dispatch(
      bidSessionActions.default.switchPriority(type, oldScore, bidSession)
    ),
  updateAllScores: preferences =>
    dispatch(bidSessionActions.default.updateAllScores(preferences)),
  updateWeight: (preference, newScore, bidMode, prefIds) =>
    dispatch(
      bidSessionActions.default.updateWeight(
        preference,
        newScore,
        bidMode,
        prefIds
      )
    ),
  updateWeightAll: (preference, newScore, bidMode, prefIds) =>
    dispatch(
      bidSessionActions.default.updateWeightForAll(
        preference,
        newScore,
        bidMode,
        prefIds
      )
    ),
  updateOtherOption: (otherOptionCode, bidSessionId, staffId, value) =>
    dispatch(
      bidSessionActions.default.updateOtherOption(
        otherOptionCode,
        bidSessionId,
        staffId,
        value
      )
    ),
  reorderReserveline: (
    staffId,
    standingBidSessionId,
    categoryId,
    reorderedReserveline
  ) =>
    dispatch(
      bidSessionActions.default.reorderReserveline(
        staffId,
        standingBidSessionId,
        categoryId,
        reorderedReserveline
      )
    ),

  updateCalendar: activities =>
    dispatch(linearCalendarActions.default.updateCalendar(activities)),
  fetchActivities: (staffId, startDate, endDate, bidSessionId, categoryId) =>
    dispatch(
      linearCalendarActions.default.fetchActivities(
        staffId,
        startDate,
        endDate,
        bidSessionId,
        categoryId
      )
    ),
  updateBidSession: bidSession => dispatch(updateBidSessionSuccess(bidSession)),
  copyCombinedPreference: (employeeBidId, groupName) =>
    dispatch(copyCombinedPreference(employeeBidId, groupName)),
  importPreviousBidPreferences: (
    staffId,
    currentBidSessionId,
    previousBidSessionId,
    bidPreferences
  ) =>
    dispatch(
      importPreviousBidPreferences(
        staffId,
        currentBidSessionId,
        previousBidSessionId,
        bidPreferences
      )
    ),
  fetchOtherOptions: (staffId, bidSessionId, categoryId) =>
    dispatch(
      linearCalendarActions.default.fetchOtherOptions(staffId, bidSessionId, categoryId)
    ),
  fetchBidPreferences: (staffId, bidSessionId) =>
    dispatch(
      bidSessionActions.default.fetchBidPreferences(staffId, bidSessionId)
    ),
});

const ConnectedBidSession = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BidSession)
);

function BidSessionWrapper(props) {
  const { labels } = useLanguage();
  return <ConnectedBidSession {...props} labels={labels} />;
}

export default BidSessionWrapper;
